// src/services/userService.js
import api from './api';

export const getTenantUsers = async () => {
    const tenantId = localStorage.getItem('tenantId');
    return api.get(`/tenants/${tenantId}/users`);
};

export const addTenantUser = async (userData) => {
    const tenantId = localStorage.getItem('tenantId');
    return api.post(`/tenants/${tenantId}/users`, userData);
};

export const deleteTenantUser = async (userId) => {
    const tenantId = localStorage.getItem('tenantId');
    // Use the correct endpoint format that matches the router
    return api.delete(`/tenants/${tenantId}/users/${userId}`);
};

export const getCurrentUser = () => {
    const token = localStorage.getItem('token');
    if (!token) return null;

    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const payload = JSON.parse(window.atob(base64));
        return payload;
    } catch (error) {
        console.error('Error decoding token:', error);
        return null;
    }
};